import React from 'react';
import { Button, Grid, Form } from 'semantic-ui-react';
import _ from 'lodash';
import styles from './FormPreview.module.css';
// eslint-disable-next-line import/no-cycle
import { ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING, getCompatibleFormValue } from './FormUtils';
import deleteIcon from '../../../icons/del.png';

export default function ExpandingCombo({ item, formik, handleChange, isCommonFieldDisabled }) {
  const expandingComboValues = _.get(formik.values, item.id);
  const onAddButtonClicked = () => {
    const newExpandingComboValue = {};
    item.elements.forEach((element) => {
      newExpandingComboValue[element.id] = getCompatibleFormValue({ item: element });
    });
    formik.setFieldValue(item.id, [...expandingComboValues, newExpandingComboValue], false);
  };
  const onDeleteButtonClicked = (index) => {
    const newExpandingComboValues = [...expandingComboValues];
    newExpandingComboValues.splice(index, 1);
    formik.setFieldValue(item.id, newExpandingComboValues, false);
  };
  return (
    <>
      <div
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 20px' }}
        className={styles.sectionHeaderConainer}
      >
        <div>{item.attributeObj.label}</div>
        <span>
          {expandingComboValues && expandingComboValues.length < (item.state.maximumSteps || 10) && (
            <Button className="black" type="button" onClick={onAddButtonClicked}>
              Add
            </Button>
          )}
        </span>
      </div>
      <Grid className="joyn2-grid">
        {expandingComboValues
          ? expandingComboValues.map((expandingComboValue, index) => {
              return (
                <Grid.Row key={index}>
                  <Grid.Column width={16} style={{ marginBottom: '25px' }}>
                    <div
                      style={{
                        display: 'inline-flex',
                        background: '#f6f6f6',
                        padding: '0 20px',
                        height: '32px',
                        alignItems: 'center',
                      }}
                    >
                      <span>{`${index + 1}. ${item.attributeObj.label}`}</span>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      {expandingComboValues?.length !== 1 && (
                        <img
                          onClick={() => onDeleteButtonClicked(index)}
                          style={{ cursor: 'pointer', height: '22px' }}
                          src={deleteIcon}
                        />
                      )}
                    </div>
                  </Grid.Column>
                  {item.elements.map((element) => {
                    const attributeObj = {
                      ...element.attributeObj,
                      id: `${item.id}[${index}].${element.id}`,
                      name: `${item.id}[${index}].${element.id}`,
                    };
                    return (
                      <Grid.Column width={16 * element.size} key={element.id}>
                        <Form.Field>
                          {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[element.type]({
                            attributeObj,
                            formik,
                            handleChange,
                            isCommonFieldDisabled,
                          })}
                        </Form.Field>
                      </Grid.Column>
                    );
                  })}
                </Grid.Row>
              );
            })
          : null}
      </Grid>
      <div
        style={{
          borderBottom: '1px dashed',
          width: '90%',
          marginRight: 'auto',
          marginLeft: 'auto',
          marginTop: '20px',
          marginBottom: '32px',
        }}
      />
    </>
  );
}
